// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VRu0","newExpiryDate":"styles_newExpiryDate__-l4kL","footer":"styles_footer__2-eKQ"};